import 'js/src/libs/set-webpack-nonce';
import 'core-js/stable';
import 'js/src/libs/page-initialization';
import 'bootstrap';
import 'regenerator-runtime/runtime';

import 'css/src/global';

import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';

import { ErrorReporter, Project } from 'js/src/libs/error-reporter';
import type { ThemesPageProps } from 'js/src/ssr/themes-page-app';
import { prepareThemesPage, ThemesPageApp } from 'js/src/ssr/themes-page-app';

ErrorReporter.init(Project.FRONTEND);

const PROPS_ELEMENT_ID = 'themes-page-props';

function readProps(): ThemesPageProps {
    const element = document.getElementById(PROPS_ELEMENT_ID);
    if (!element?.textContent) {
        return { templates: [], categories: [], openTemplateId: null, contentfulPageListings: [] };
    }
    return JSON.parse(element.textContent) as ThemesPageProps;
}

const props = readProps();
const store = prepareThemesPage(props);

const container = document.getElementById('react-root');
if (!container) {
    throw new Error('Could not find #react-root element');
}

const app = <ThemesPageApp props={props} store={store} />;

// Hydrate whatever the render service produced; mount from scratch when it produced nothing,
// which is what happens whenever server rendering is off or unavailable.
if (container.hasChildNodes()) {
    hydrateRoot(container, app);
} else {
    createRoot(container).render(app);
}
